// @flow
import React from 'react'
import TopicItemCard, {
  type PropTypes as TopicItemCardTypes,
} from 'components/molecules/TopicListItem'

export type PropTypes = {
  topicItemCardPropsList: Array<TopicItemCardTypes>,
}

export default (props: PropTypes) => (
  <div className="container">
    <div className="page-xs12-head">
      <h1 className="page-title">{i18n.t('page.topicList.title')}</h1>
      <p className="page-description">
        {i18n.t('page.topicList.pageDescriptionFirst')}
        <br className="sm-hide" />
        {i18n.t('page.topicList.pageDescription')}
      </p>
    </div>
    <div className="row">
      {props.topicItemCardPropsList.map(item => (
        <TopicItemCard {...item} key={item.id} />
      ))}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/pages/TopicListPage/index.jsx